const FreeShippingTrackerComponent = {
  name: '_FreeShippingTracker_',
  inputs: [],
} as const;

export default FreeShippingTrackerComponent;
